import * as React from 'react';
import { LinkButton, useDeviceType } from '@cian/ui-kit';

import { PageHeaderContainer } from '../PageHeader';
import { AddBlogPostFormContainer } from '../AddPostForm';
import { PageWithSidebar as Layout } from '../../components/Layouts';
import { SidebarPostPublicationProhibitions, SidebarPostPublicationRules } from '../../components/SidebarTips';
import { EmptyBox } from '../../components/Box';
import { CIAN_SUPPORT_HOW_TO_BLOG } from '../../constants';

/**
 * Контейнер страницы добавления/редактирования поста блога
 */
export const AddBlogPageContainer = () => {
  const deviceType = useDeviceType();

  return (
    <Layout header={<PageHeaderContainer />} body={<AddBlogPostFormContainer />}>
      <SidebarPostPublicationRules />
      <SidebarPostPublicationProhibitions />
      <EmptyBox marginTop={deviceType === 'phone' ? 'var(--unit_2)' : 'var(--unit_4)'} />
      <LinkButton
        href={CIAN_SUPPORT_HOW_TO_BLOG}
        theme={'fill_secondary'}
        target={'_blank'}
        fullWidth={deviceType === 'phone'}
      >
        Все правила публикации
      </LinkButton>
    </Layout>
  );
};
